import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Button, CardContent, Grid, TextField, Typography } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { z } from 'zod';
import showToast from '../../../../../components/Hot-Toast/showToast';
import { useTMutation } from '../../../../../utils/useTMutation';
import { useTQuery } from '../../../../../utils/useTQuery';
// import { previousStep, update } from '../../../../../slice/multiStepSlice';
// import { nextStep } from '../../../../../slice/onBoardWizardSlice';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { customStep, nextStep, previousStep, update } from '../../../../../slice/multiStepSlice';


// Define schema for form validation
export const roleSchema = z.object({
    assessmentName:z.string().min(1, { message: "At least one role must be selected" }),
});

const CreateAssessment = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { values } = useSelector((state) => state?.multiStep)
    const [roles, setRoles] = useState([]);
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [assessmentName, setAssessmentName] = useState('');
    const { data: rolesData } = useTQuery(
        "jobs_roles",
        "/jobRoles",
        "post"
    );

   
    const {
        control,
        handleSubmit,
        register,
        setValue,
        clearErrors,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(roleSchema),
        defaultValues: { assessmentName : values ?.adminScheduleAssessment && values?.adminScheduleAssessment[0]?.assessmentName || "" },
    });



    const submitAssessmentName = async (formData) => {
        console.log("Job Data",formData )

                dispatch(update({ assessmentName: formData?.assessmentName }))
                dispatch(nextStep())
                // navigate("/admin/profile-criteria/fetchSpecialtyRoleMappings")
    };


    return (
        <>
            {!values.REDIRECT && <Button
                onClick={() => dispatch(customStep(2))}
                startIcon={<ArrowBackIosIcon sx={{ fontSize: "12px", color: "#000000" }} />}
                sx={{ textTransform: 'none', fontWeight: 500, fontSize: "14px", padding: 3, minWidth: 0 }}
            >
            </Button>}
            <Grid lg={12} p={4}>

                <CardContent>
                    <Typography variant="h2" component="div" mb={4} fontWeight="bold">
                        Create assessment
                    </Typography>
                    <form onSubmit={handleSubmit(submitAssessmentName)}>

                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            <TextField
                                label="Assessment Name"
                                variant="outlined"
                                fullWidth
                                inputProps={{ maxLength: 30 }}
                                {...register("assessmentName")}
                                onChange={(e) => setAssessmentName(e.target.value)}
                                margin="normal"
                                autoFocus={true}
                                error={!!errors.assessmentName}
                                helperText={errors.assessmentName?.message}
                                sx={{
                                    '& .MuiOutlinedInput-input': { padding: 1.94 },
                                    '& .MuiFormHelperText-root': { marginLeft: 0, marginTop: '4px' },
                                }}
                            />

                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', }}>
                                <Button
                                    // variant="contained" sx={{ backgroundColor: '#6ebe44' }} 
                                    className='gradientAdminThemeColor'
                                    type='submit'>
                                    Next
                                </Button>
                            </Box>
                        </Box>
                    </form>
                </CardContent>



            </Grid>

        </>
    );
};

export default memo(CreateAssessment);
